<template>
  <v-container justify-center>
    <ResetPasswordForm />
  </v-container>
</template>

<script>
import ResetPasswordForm from '@/components/ResetPasswordForm'

export default {
  name: 'Reset-password',
  components: {
    ResetPasswordForm
  }
}
</script>
